import { getThemeColor } from 'style-utils/theme/utils/getThemeColor';
import styled, { css } from 'styled-components';

type SingleStepCircleProps = {
  isActive: boolean;
  isCompleted: boolean;
};

export const SingleStepCircle = styled.div<SingleStepCircleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-family: 'Muli';
  font-style: normal;
  font-weight: 800;
  font-size: 2rem;
  line-height: 2.5rem;
  width: 3rem;
  height: 3rem;
  border: 1px solid ${getThemeColor('bgPrimary')};
  border-radius: 50%;
  color: ${getThemeColor('textThertiary')};

  ${({ isCompleted }) =>
    isCompleted
      ? css`
          color: #243487;
          background: #d5d8d9;
          font-weight: 500;
        `
      : css`
          color: ${getThemeColor('secondary')};
          background: #adb3d2;
          font-weight: 800;
        `}

  ${({ isActive }) =>
    isActive &&
    css`
      width: 4.4rem;
      height: 4.4rem;
      background: ${getThemeColor('bgPrimary')};
      color: white;
      font-weight: 800;
    `}
`;

SingleStepCircle.displayName = 'SingleStepCircle';
